import * as Sentry from '@sentry/react';

import { getUserId, getUserFullName } from '@braindate/domain/lib/user/util';
import { assertObject } from '@braindate/util/lib/assert';

import type { User } from '@braindate/domain/lib/user/type';

export function registerSentryUserFromBrowser(user: User): void {
  assertObject(user, 'user');

  Sentry.configureScope((scope) => {
    scope.setUser({ id: getUserId(user), username: getUserFullName(user) });
  });
}

export function unregisterSentryUserFromBrowser(): void {
  Sentry.configureScope((scope) => {
    scope.setUser();
  });
}
